export const SCHOOL_LIST_SUCCESS="master/SCHOOL_LIST_SUCCESS";
export const SCHOOL_LIST_FAILURE="master/SCHOOL_LIST_FAILURE";